// A tab opened with this query param shows no announcements for its session.
const ANNOUNCEMENTS_OFF_PARAM = "mmc_announcements";
const ANNOUNCEMENTS_OFF_VALUE = "off";

// Any origin works: only the path, query and hash are read back.
const PATH_BASE = "http://localhost";

export const addAnnouncementsOffParam = (path: string): string => {
  const url = new URL(path, PATH_BASE);
  url.searchParams.set(ANNOUNCEMENTS_OFF_PARAM, ANNOUNCEMENTS_OFF_VALUE);
  return `${url.pathname}${url.search}${url.hash}`;
};

export const removeAnnouncementsOffParam = ({
  hash,
  pathname,
  search,
}: Pick<Location, "hash" | "pathname" | "search">): string | undefined => {
  const params = new URLSearchParams(search);
  if (!params.has(ANNOUNCEMENTS_OFF_PARAM)) {
    return undefined;
  }
  params.delete(ANNOUNCEMENTS_OFF_PARAM);
  const query = params.toString();
  return `${pathname}${query ? `?${query}` : ""}${hash}`;
};
